{% block sw_theme_manager_list %}
<sw-page class="sw-theme-list">

    {% block sw_theme_manager_list_search_bar %}
    <template #search-bar>
        <sw-search-bar
            :placeholder="$t('sw-theme-manager.general.placeholderSearchBar')"
            :initial-search-type="$t('sw-theme-manager.general.mainMenuItemGeneral')"
            @search="onSearch"
        />
    </template>
    {% endblock %}

    {% block sw_theme_manager_list_toolbar %}
    <template #smart-bar-header>
        <h2> {{ $t('sw-theme-manager.general.mainMenuItemGeneral') }}</h2>
    </template>
    {% endblock %}

    {% block sw_theme_list_card_view %}
    <template #content>
        <sw-card-view>

            {% block sw_themes_list_listing %}
            <div class="sw-theme-list__content">

                {% block sw_theme_list_listing_actions %}
                <div class="sw-theme-list__actions">

                    {% block sw_theme_list_listing_title %}
                    <h3>{{ $t('sw-theme-manager.general.mainMenuHeader') }}</h3>
                    {% endblock %}

                    {% block sw_theme_list_listing_actions_sorting %}
                    <div class="sw-theme-list__actions-sorting">
                        <sw-sorting-select
                            :sort-by="sortBy"
                            :sort-direction="sortDirection"
                            @sorting-changed="onSortingChanged"
                        />
                    </div>
                    {% endblock %}

                    {% block sw_theme_list_listing_actions_mode %}
                    <div
                        class="sw-theme-list__actions-mode"
                        @click="onListModeChange"
                    >
                        <mt-icon
                            v-if="listMode === 'grid'"
                            name="regular-view-normal"
                            size="16"
                        />
                        <mt-icon
                            v-if="listMode === 'list'"
                            name="regular-view-grid"
                            size="16"
                        />
                    </div>
                    {% endblock %}
                </div>
                {% endblock %}

                {% block sw_theme_list_listing_list %}
                <div class="sw-theme-list__list">

                    {% block sw_theme_list_listing_list_card %}
                    <mt-card v-if="listMode === 'list'" class="sw-theme-list__list-card">
                        <template #grid>

                            {% block sw_theme_list_listing_list_data_grid %}
                            <sw-data-grid
                                class="sw-theme-list__list-data-grid"
                                identifier="sw-theme-list"
                                :is-loading="isLoading"
                                :data-source="themes"
                                :columns="columnConfig"
                                :skeleton-item-amount="limit"
                                :sort-by="sortBy"
                                :sort-direction="sortDirection"
                                :allow-inline-edit="false"
                                :allow-column-edit="false"
                                :show-settings="false"
                                :show-selection="false"
                                @column-sort="onSortColumn"
                            >

                                {% block sw_theme_list_listing_list_data_grid_column_name %}
                                <template #column-name="{ item }">
                                    <mt-icon
                                        v-if="item.technicalName"
                                        v-tooltip="lockToolTip"
                                        name="regular-lock"
                                        class="sw-theme-list__icon-lock"
                                        size="14"
                                    />
                                    <router-link :to="{ name: 'sw.theme.manager.detail', params: { id: item.id } }">
                                        {{ item.name }}
                                    </router-link>
                                </template>
                                {% endblock %}

                                {% block sw_theme_list_listing_list_data_grid_column_assignment %}
                                <template #column-assignment="{ item }">
                                    {{ item.salesChannels.length }}
                                </template>
                                {% endblock %}

                                {% block sw_theme_list_listing_list_data_grid_column_created %}
                                <template #column-createdAt="{ item }">
                                    {{ dateFilter(item.createdAt, { hour: '2-digit', minute: '2-digit' }) }}
                                </template>
                                {% endblock %}

                                {% block sw_theme_list_listing_list_data_grid_actions %}
                                <template #actions="{ item }">
                                    {% block sw_theme_list_listing_list_data_grid_actions_edit %}
                                    <sw-context-menu-item
                                        class="sw-theme-list-item__option-edit"
                                        :router-link="{ name: 'sw.theme.manager.detail', params: { id: item.id } }"
                                    >
                                        {{ $t('global.default.edit') }}
                                    </sw-context-menu-item>
                                    {% endblock %}

                                    {% block sw_theme_list_listing_list_data_grid_actions_rename %}
                                    <sw-context-menu-item
                                        class="sw-theme-list-item__option-rename"
                                        :disabled="!acl.can('theme.editor')"
                                        @click="onRenameTheme(item)"
                                    >
                                        {{ $t('sw-theme-manager.themeListItem.rename') }}
                                    </sw-context-menu-item>
                                    {% endblock %}

                                    {% block sw_theme_list_listing_list_data_grid_actions_delete %}
                                    <sw-context-menu-item
                                        v-if="!item.technicalName"
                                        v-tooltip="deleteDisabledToolTip(item)"
                                        variant="danger"
                                        class="sw-theme-list-item__option-delete"
                                        :disabled="item.salesChannels.length > 0 || !acl.can('theme.deleter')"
                                        @click="onDeleteTheme(item)"
                                    >

                                        {{ $t('global.default.delete') }}
                                    </sw-context-menu-item>
                                    {% endblock %}

                                    {% block sw_theme_list_listing_list_data_grid_actions_create %}
                                    <sw-context-menu-item
                                        v-if="item.technicalName"
                                        class="sw-theme-list-item__option-duplicate"
                                        :disabled="!acl.can('theme.creator')"
                                        @click="onDuplicateTheme(item)"
                                    >
                                        {{ $t('global.default.duplicate') }}
                                    </sw-context-menu-item>
                                    {% endblock %}
                                </template>
                                {% endblock %}

                                {% block sw_theme_list_listing_list_data_grid_pagination %}
                                <template #pagination>
                                    <sw-pagination
                                        :page="page"
                                        :limit="limit"
                                        :total="total"
                                        :steps="[5, 10, 25, 50]"
                                        @page-change="onPageChange"
                                    />
                                </template>
                                {% endblock %}
                            </sw-data-grid>
                            {% endblock %}
                        </template>
                    </mt-card>
                    {% endblock %}

                    {% block sw_theme_list_listing_list_grid %}
                    <div v-if="listMode === 'grid'" class="sw-theme-list__list-grid">

                        {% block sw_theme_list_listing_list_grid_content %}
                        <div class="sw-theme-list__list-grid-content">
                            {% block sw_theme_list_listing_list_item %}
                            <template v-if="!isLoading">
                                <sw-theme-list-item
                                    v-for="theme in themes"
                                    :key="theme.id"
                                    :theme="theme"
                                    @preview-image-change="onPreviewChange"
                                    @item-click="onListItemClick"
                                >

                                    <template #contextMenu>
                                        <sw-context-button
                                            :z-index="1100"
                                            class="sw-theme-list-item__options"
                                        >

                                            {% block sw_theme_list_listing_list_item_option_add_preview %}
                                            <sw-context-menu-item
                                                class="sw-theme-list-item__option-preview"
                                                :disabled="!acl.can('theme.editor')"
                                                @click="onPreviewChange(theme)"
                                            >
                                                {{ $t('sw-theme-manager.themeListItem.addPreviewImage') }}
                                            </sw-context-menu-item>
                                            {% endblock %}

                                            {% block sw_theme_list_listing_list_item_option_remove_preview %}
                                            <sw-context-menu-item
                                                v-if="theme.previewMediaId"
                                                variant="danger"
                                                class="sw-theme-list-item__option-preview sw-theme-list-item__option-preview-remove"
                                                :disabled="!acl.can('theme.editor')"
                                                @click="onPreviewImageRemove(theme)"
                                            >
                                                {{ $t('sw-theme-manager.themeListItem.removePreviewImage') }}
                                            </sw-context-menu-item>
                                            {% endblock %}

                                            {% block sw_theme_list_listing_list_item_option_rename %}
                                            <sw-context-menu-item
                                                class="sw-theme-list-item__option-rename"
                                                :disabled="!acl.can('theme.editor')"
                                                @click="onRenameTheme(theme)"
                                            >
                                                {{ $t('sw-theme-manager.themeListItem.rename') }}
                                            </sw-context-menu-item>
                                            {% endblock %}

                                            {% block sw_theme_list_listing_list_item_option_create %}
                                            <sw-context-menu-item
                                                v-if="theme.technicalName"
                                                class="sw-theme-list-item__option-duplicate"
                                                :disabled="!acl.can('theme.creator')"
                                                @click="onDuplicateTheme(theme)"
                                            >
                                                {{ $t('global.default.duplicate') }}
                                            </sw-context-menu-item>
                                            {% endblock %}

                                            {% block sw_theme_list_listing_list_item_option_delete %}
                                            <sw-context-menu-item
                                                v-if="!theme.technicalName"
                                                v-tooltip="deleteDisabledToolTip(theme)"
                                                class="sw-theme-list-item__option-delete"
                                                variant="danger"
                                                :disabled="theme.salesChannels.length > 0 || !acl.can('theme.deleter')"
                                                @click="onDeleteTheme(theme)"
                                            >
                                                {{ $t('global.default.delete') }}
                                            </sw-context-menu-item>
                                            {% endblock %}
                                        </sw-context-button>
                                    </template>
                                </sw-theme-list-item>
                            </template>

                            <template v-else>
                                <sw-skeleton variant="gallery" />
                                <sw-skeleton variant="gallery" />
                                <sw-skeleton variant="gallery" />
                                <sw-skeleton variant="gallery" />
                                <sw-skeleton variant="gallery" />
                                <sw-skeleton variant="gallery" />
                                <sw-skeleton variant="gallery" />
                                <sw-skeleton variant="gallery" />
                                <sw-skeleton variant="gallery" />
                            </template>
                            {% endblock %}
                        </div>
                        {% endblock %}

                        {% block sw_theme_list_listing_pagination %}
                        <sw-pagination
                            v-if="!isLoading"
                            class="sw-theme-list__list-pagination"
                            :page="page"
                            :limit="limit"
                            :total="total"
                            :steps="[9]"
                            @page-change="onPageChange"
                        />
                        {% endblock %}
                    </div>
                    {% endblock %}
                </div>
                {% endblock %}
            </div>
            {% endblock %}

            {% block sw_theme_list_media_modal %}
            <sw-media-modal-v2
                v-if="showMediaModal"
                :caption="$t('sw-theme-manager.general.captionMediaUpload')"
                entity-context="theme"
                :allow-multi-select="false"
                @media-modal-selection-change="onPreviewImageChange"
                @modal-close="onModalClose"
            />
            {% endblock %}

            {% block sw_theme_list_delete_modal %}
            <sw-modal
                v-if="showDeleteModal"
                :title="$t('global.default.warning')"
                variant="small"
                @modal-close="onCloseDeleteModal"
            >

                {% block sw_theme_list_delete_modal_info %}
                <div class="sw_theme_manager__confirm-delete-text">
                    {{ $t('sw-theme-manager.modal.textDeleteInfo', { themeName: modalTheme.name }) }}
                </div>
                {% endblock %}

                {% block sw_theme_list_delete_modal_footer %}
                <template #modal-footer>
                    {% block sw_theme_list_delete_modal_cancel %}
                    <mt-button
                        variant="secondary"
                        size="small"
                        @click="onCloseDeleteModal"
                    >
                        {{ $t('global.default.cancel') }}
                    </mt-button>
                    {% endblock %}

                    {% block sw_theme_list_delete_modal_confirm %}
                    <mt-button
                        variant="critical"
                        size="small"
                        @click="onConfirmThemeDelete"
                    >
                        {{ $t('global.default.delete') }}
                    </mt-button>
                    {% endblock %}
                </template>
                {% endblock %}
            </sw-modal>
            {% endblock %}

            {% block sw_theme_list_duplicate_modal %}
            <sw-modal
                v-if="showDuplicateModal"
                class="sw_theme_manager__duplicate-modal"
                :title="$t('sw-theme-manager.modal.modalTitleDuplicate')"
                variant="small"
                @modal-close="onCloseDuplicateModal"
            >

                {% block sw_theme_list_duplicate__modal_name_input %}
                <div class="sw_theme_manager__duplicate-info">
                    {{ $t('sw-theme-manager.modal.textDuplicateInfo') }}
                </div>

                <mt-text-field
                    v-model="newThemeName"
                    name="sw-field--duplicate-theme-name"
                    :label="$t('sw-theme-manager.modal.labelDuplicateThemeName')"
                    :placeholder="$t('sw-theme-manager.modal.placeholderDuplicateThemeName')"
                />
                {% endblock %}

                {% block sw_theme_list_duplicate_modal_footer %}
                <template #modal-footer>
                    {% block sw_theme_list_duplicate_modal_cancel %}
                    <mt-button
                        variant="secondary"
                        size="small"
                        @click="onCloseDuplicateModal"
                    >
                        {{ $t('global.default.cancel') }}
                    </mt-button>
                    {% endblock %}

                    {% block sw_theme_list_duplicate_modal_confirm %}
                    <mt-button
                        variant="primary"
                        :disabled="newThemeName.length < 3"
                        size="small"
                        @click="onConfirmThemeDuplicate"
                    >
                        {{ $t('global.default.duplicate') }}
                    </mt-button>
                    {% endblock %}
                </template>
                {% endblock %}
            </sw-modal>
            {% endblock %}

            {% block sw_theme_list_rename_modal %}
            <sw-modal
                v-if="showRenameModal"
                class="sw_theme_manager__rename-modal"
                :title="$t('sw-theme-manager.modal.modalTitleRename')"
                variant="small"
                @modal-close="onCloseRenameModal"
            >

                {% block sw_theme_list_rename__modal_name_input %}
                <div class="sw_theme_manager__rename-info">
                    {{ $t('sw-theme-manager.modal.textRenameInfo') }}
                </div>

                <mt-text-field
                    v-model="newThemeName"
                    name="sw-field--rename-theme-name"
                    :label="$t('sw-theme-manager.modal.labelRenameThemeName')"
                    :placeholder="$t('sw-theme-manager.modal.placeholderRenameThemeName')"
                />
                {% endblock %}

                {% block sw_theme_list_rename_modal_footer %}
                <template #modal-footer>
                    {% block sw_theme_list_rename_modal_cancel %}
                    <mt-button
                        variant="secondary"
                        size="small"
                        @click="onCloseRenameModal"
                    >
                        {{ $t('global.default.cancel') }}
                    </mt-button>
                    {% endblock %}

                    {% block sw_theme_list_rename_modal_confirm %}
                    <mt-button
                        variant="primary"
                        :disabled="newThemeName.length < 3"
                        size="small"
                        @click="onConfirmThemeRename"
                    >
                        {{ $t('global.default.save') }}
                    </mt-button>
                    {% endblock %}
                </template>
                {% endblock %}
            </sw-modal>
            {% endblock %}
        </sw-card-view>
    </template>
    {% endblock %}
</sw-page>
{% endblock %}
